import { getConferenceState } from '../../../react/features/base/conference/functions';
import {
    getFakeParticipants,
    getRemoteParticipantCountWithFake
} from '../../../react/features/base/participants/functions';
import { isWebinarEnabledInRoom } from '../../../x-bees/components/webinar/functions';

export function isAlone(stateful) {
    const state = stateful || APP.store.getState();
    const count = getRemoteParticipantCountWithFake(state) - getFakeParticipants(state).size;

    return count === 0 && !isWebinarEnabledInRoom(state);
}

export const getIsConferenceJoined = state => Boolean(getConferenceState(state).conference);
